var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "row" }, [
    _c("div", { staticClass: "col-md-12 px-0" }, [
      _c(
        "ol",
        { staticClass: "breadcrumb smaller-font-content" },
        _vm._l(_vm.crumbs, function(crumb, key) {
          return crumb.meta && crumb.meta.title
            ? _c(
                "li",
                {
                  key: key,
                  class: {
                    "breadcrumb-item": true,
                    active: key === _vm.crumbs.length - 1
                  }
                },
                [
                  key !== _vm.crumbs.length - 1
                    ? _c(
                        "router-link",
                        {
                          class: { "breadcrumb-first-item": key === 0 },
                          attrs: { to: crumb.path }
                        },
                        [_vm._v(_vm._s(crumb.meta.title))]
                      )
                    : _c("span", [_vm._v(_vm._s(crumb.meta.title))])
                ],
                1
              )
            : _vm._e()
        }),
        0
      )
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-5b426d74", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5b426d74","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0&bustCache!./src/components/presentational/widgets/Breadcrumbs.vue
// module id = null
// module chunks = 